<template>
    <div class="container mt-4">
        <div class="mb-3" style="font-size: 18px;font-weight: bold;">
            <i class="bi bi-person-plus-fill text-success"></i> Create Data Template
        </div>
        <!-- <div class="border-top border-success mb-4"></div> -->
        <div class="row mt-2">
            <div class="col-md-6">
                <div class="mb-3">
                    <label class="form-label"><i class="bi bi-envelope"></i> Template Name</label>
                    <input type="email" class="form-control" placeholder="Name" v-model="template.name">
                </div>
                <div>Add Item</div>
                <div class="bg-light rounded-4 px-3 py-3" style="font-size: 14px;">
                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Data Type
                        </div>
                        <div class="col-9">
                            <select v-model="template.type" class="col-12" style="height: 35px;">
                                <option disabled value="">Please select Data type</option>
                                <option>Data</option>
                                <option>Control</option>
                            </select>
                            <!-- <input type="text" class="form-control" placeholder="" v-model="template.value_type"> -->
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Label
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" placeholder="eg. Voltage 1" v-model="template.label">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Key
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" placeholder="eg. v1" v-model="template.key">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Value Type
                        </div>
                        <div class="col-9">
                            <select v-model="template.value_type" class="col-12" style="height: 35px;">
                                <option disabled value="">Please select type</option>
                                <option>float</option>
                                <option>int</option>
                                <option>bool</option>
                            </select>
                            <!-- <input type="text" class="form-control" placeholder="" v-model="template.value_type"> -->
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Unit
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" placeholder="Volt (V)" v-model="template.unit">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-3 text-end">
                            Widget Type
                        </div>
                        <div class="col-9">
                            <select v-model="template.widget_type" class="col-12" style="height: 35px;">
                                <option disabled value="">Please select widget type</option>
                                <option>realtime</option>
                                <option>gauge</option>
                                <option>chart</option>
                                <option>notification</option>
                            </select>
                            <!-- <input type="text" class="form-control" placeholder="" v-model="template.value_type"> -->
                        </div>
                        <!-- <div class="col-9">
                            <input type="text" class="form-control" placeholder="" v-model="template.widget_type">
                        </div> -->
                    </div>
                    <div class=" text-end mt-3">
                        <button type="button" class="btn btn-light bg-white border" @click="addItemToTemplate()">+ Add
                            Item</button>
                    </div>
                </div>

            </div>
            <!-- Right Section -->
            <div class="col-md-6">
                <div>List Items</div>
                <div style="height: 250px;" class=" rounded-4 bg-light">
                    <div class="row px-2 py-2">
                        <div class="col-6" v-for="(item,index) in items" :key="item">
                            <div class="rounded-5  px-2 py-1 mt-2" style=" border: 1px solid #2F90DC;">
                                <div class="row">
                                    <div class="col-10">
                                {{ item.label }}
                                    </div>
                                    <div class="col-2">
                                        <font-awesome-icon class="" type="button" @click="items.splice(index, 1);" style="color: red;font-size: 20px;"
                                            :icon="['fas', 'circle-xmark']" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-3 mt-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i>Description</label>
                    <textarea class="form-control rounded-4" rows="4" placeholder="" v-model="template.description"></textarea>
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between mt-4">
            <button class="btn btn-danger px-4" @click="clearForm">
                <i class="bi bi-brush"></i> Clear
            </button>
            <button class="btn btn-secondary px-4" @click="createTemplate()">
                <i class="bi bi-person-plus"></i> Create
            </button>
        </div>
    </div>

</template>

<script setup>
    import {
        ref
    } from "vue";

    const email = ref("");
    const fullName = ref("");
    const role = ref("User");
    const note = ref("");

    const clearForm = () => {
        email.value = "";
        fullName.value = "";
        role.value = "User";
        note.value = "";
    };
</script>
<script>
    import CryptoJS from "crypto-js";
    //   import jwt from "jsonwebtoken";
    export default {
        data() {
            return {
                template: {
                    label:"",
                    name: "",
                    key: "",
                    value_type: "",
                    unit: "",
                    widget_type: "",
                    description:"",
                    type:"Data",
                },
                items: [],
                device: {

                    note: "",
                    mode: "api",
                    model: "",

                },
                api: {
                    mode: "basic",
                    in: "",
                    key: "",
                    value: "",
                    username: "",
                    password: ""
                },
                mqtt: {
                    id: "cxaksjyteqhw",
                    topic: "",
                    username: "",
                    password: ""
                }
            }
        },
        methods: {
            addItemToTemplate() {
                this.items.push({
                    label:this.template.label,
                    key: this.template.key,
                    value_type: this.template.value_type,
                    unit: this.template.unit,
                    widget_type: this.template.widget_type,
                    type:this.template.type
                })
                this.template.label =""
                this.template.key =""
                this.template.value_type =""
                this.template.unit =""
                this.template.widget_type =""
                this.template.type =""

            },

            generateKey_MQTT() {
                this.mqtt.id = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Base64);
                this.mqtt.username = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
                this.mqtt.password = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64);
            },
            copyTextFallback(text) {
                const textarea = document.createElement("textarea");
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            },

            async createTemplate() {
                try {

                    var accessToken = localStorage.getItem("accessToken");
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        },
                        body: JSON.stringify({
                            "name": this.template.name,
                            "description": this.template.description,
                            "items": this.items
                        })
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const result = await response.json();
                    this.$router.push('/device/listtemplate');
                    console.log('Dashboard page created:', result);
                } catch (error) {
                    console.error('Error creating dashboard page:', error);
                }

            },
        },
        created() {

        }
    }
</script>

<style scoped>
    /* Add extra styling if needed */
</style>